import React from 'react';
import _get from 'lodash/get';
import RichTextDefault from './RichTextDefault';
import RichTextExpanded from './RichTextExpanded';

interface Props {
  values: any;
  onSetFieldValue: (fieldKey: string, fieldValue: string) => void;
  originalValue: any;
  shouldReset?: boolean;
  errors?: any;
  resetShouldReset: () => void;
}

function RichTextWidgetSettings({
  values,
  onSetFieldValue,
  originalValue,
  shouldReset,
  resetShouldReset,
  errors,
}: Props) {
  const defaultContent = _get(values, ['settings', 'richTextDefault']);
  const expandedContent = _get(values, ['settings', 'richTextExpanded']);
  const originalDefaultValue = _get(originalValue, ['settings', 'richTextDefault']);
  const originalExpandedValue = _get(originalValue, ['settings', 'richTextExpanded']);

  return (
    <>
      <RichTextDefault
        value={defaultContent}
        onSetFieldValue={onSetFieldValue}
        originalValue={originalDefaultValue}
        shouldReset={shouldReset}
        resetShouldReset={resetShouldReset}
        errors={errors}
      />
      <RichTextExpanded
        value={expandedContent}
        onSetFieldValue={onSetFieldValue}
        originalValue={originalExpandedValue}
        shouldReset={shouldReset}
        resetShouldReset={resetShouldReset}
        errors={errors}
      />
    </>
  );
}

export default RichTextWidgetSettings;
